<template>
  <v-container fluid id="crm">
    <v-layout wrap>
      <v-flex xs12 sm4>
        <h2 class="title">{{ $t('Customer') }}</h2>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <v-btn outline loading color="grey"></v-btn>
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
            <v-btn color="grey" outline>
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <i class="fas fa-file-export"></i>
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" :disabled="delayImport" outline @click="importCustomer">
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}
            </v-btn>
            <v-btn color="grey" outline @click="onExportCustomer_superten('m')">
              <i class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }} m1-m10
            </v-btn>
            <v-btn color="grey" outline @click="onExportCustomer_superten('s')">
              <i class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }} s1-s20
            </v-btn>
          </template>
        </template>

        <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <i class="fas fa-angle-down" v-if="!showAdvance"></i>
          <i class="fas fa-angle-up" v-else></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <template>
        <v-premium-plan-popup
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <filter-customer :total_user="total_user" v-model="filter">
          <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed @click="onSearch" color="primary">
            <i class="fas fa-search mr-1"></i>
            {{ $t('Search') }}
          </v-btn>

          <div slot="append" slot-scope="{ filter }" v-if="selectedBot.theme == 'hafele'">
            <v-divider class="mt-2"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp ID') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp ID')"
                  v-model="filter.emp_id"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp First Name')"
                  v-model="filter.emp_first_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp Last Name')"
                  v-model="filter.emp_last_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
            </v-layout>
          </div>
        </filter-customer>
      </template>
    </div>
    <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination>
    <div class="ma-2 text-xs-right">
      <span class="caption mr-2">{{ $t('Total') }}</span>

      <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
        total_user | numberFormat
      }}</span>
    </div>
    <v-data-table
      :loading="loading"
      :headers="filteredHeader"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <customer-item v-model="props.item"></customer-item>
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
    </v-data-table>

    <div class="mt-4">
      <v-pagination
        :total-visible="15"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>

    <v-dialog v-model="showExport" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showExport = false"><v-icon>close</v-icon></v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <template v-for="page in exportpagecount">
              <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large> folder_shared </v-icon>
                  <div class="caption">
                    {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                    <template v-if="page == exportpagecount">
                      {{ total_user | numberFormat }}
                    </template>
                    <template v-else>
                      {{ (page * exportlimit) | numberFormat }}
                    </template>
                  </div>
                  <v-btn
                    small
                    color="primary"
                    depressed
                    :loading="loading"
                    @click="exportCustomer_superten((page - 1) * exportlimit)"
                    >download</v-btn
                  >
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Customers from './Customers.js'

import config from '@/config'
import dayjs from 'dayjs'
import XLSX from 'xlsx'

export default {
  mixins: [Customers],
  data() {
    return {
      exportTypeSuperten: ''
    }
  },
  methods: {
    exportCustomer_superten: function(offset = 0, type) {
      let vm = this
      let csvContent = ''

      var limit = 5000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function(users) {
          if (users && users.length > 0) {
            var json = []
            $.each(users, function(index, val) {
              let locale = config.locale.find(function(locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : this.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }
              var userData = {
                pageuid: userid_split,
                'Social Name':
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : ''),
                Channel: val.app,
                Gender: val.gender,
                'Register Date': val.registertimestamp
                  ? dayjs(val.registertimestamp).format('DD/MM/YYYY')
                  : '-',
                'Last Active Date': val.timestamp
                  ? dayjs(val.timestamp).format('DD/MM/YYYY')
                  : '-',
                Email:
                  vm.$store.getters.getPackage == 'premium'
                    ? val.email
                      ? val.email
                      : ''
                    : this.$t('premium'),
                Address: val.address,
                'Phone No':
                  vm.$store.getters.getPackage == 'premium' ? val.phoneno : this.$t('premium'),
                Status: vm.$store.getters.getPackage == 'premium' ? val.status : this.$t('premium'),
                Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : this.$t('premium'),
                // 'Message Sent':
                //   vm.$store.getters.getPackage == 'premium' ? val.messagesent : this.$t('premium'),
                Locale: locale ? locale : ''
                // Intent:
                //     vm.$store.getters.getPackage == 'premium'
                //         ? val.intentlist
                //             ? val.intentlist.join(',')
                //             : ''
                //         : this.$t('premium'),
                // MessageSent: val.questionmessages ? val.questionmessages.replace(/;;/gim, ',') : '',
                // NumberMessageSent: val.usermessages
              }
              if (
                vm.$store.state.supertenpage.includes(vm.selectedBot.pageid) &&
                vm.exportTypeSuperten == 'm'
              ) {
                var tagvote = val.tags ? val.tags.split(',') : []

                for (let i = 0; i < 10; i++) {
                  var voteitem = 'superten_m' + (i + 1).toString().padStart(2, '0')
                  Object.assign(userData, {
                    [voteitem]: tagvote.includes(voteitem) ? '/' : ''
                  })
                }
              } else if (
                vm.$store.state.supertenpage.includes(vm.selectedBot.pageid) &&
                vm.exportTypeSuperten == 's'
              ) {
                var tagvote = val.tags ? val.tags.split(',') : []

                for (let i = 0; i < 20; i++) {
                  var voteno = (i + 1).toString().padStart(2, '0')
                  var voteitem = 'superten_s' + voteno
                  Object.assign(userData, {
                    [voteitem]: tagvote.includes('S' + (i + 1)) ? '/' : ''
                  })
                }
              }
              json.push(userData)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const csv = XLSX.utils.sheet_to_csv(dataWS)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function() {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    onExportCustomer_superten(type) {
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)
      this.exportTypeSuperten = type
      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        this.exportCustomer_superten(0)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/SupertenCustomer.vue